<template>
	<div class="hotContent">
		<div class="cardBox">
			<div class="leftCard">
				<el-card class="box-card">
					<div class="rotation">
						<!-- 轮播图 -->
						<el-carousel :interval="5000" arrow="always" indicator-position="outside" height="350px">
							<el-carousel-item v-for="(item,index) in introduce.imgList" :key="index">
								<el-image :src="item" style="height: 350px;"></el-image>
							</el-carousel-item>
						</el-carousel>
					</div>
				</el-card>
			</div>
			<div class="rightCard">
				<el-card class="box-card">
					<h2>{{introduce.title}}</h2>
					<div v-html="introduce.content"></div>
				</el-card>
			</div>
		</div>
	</div>
</template>

<script>
	import {Decrypt,Encrypt} from '@/common/secret.js'
	export default {
		data() {
			return {
				introduce: {
					buttonTitle: '',
					title: '',
					content: '',
					imgList: []
				},
				hotId:108
			}
		},
		mounted() {
			// 查询展厅简介
			let apth = ''
			if(!this.$global.SERVER_OFFLINE) {
				path = '/api/cloudget/hotIntroduce'
			}else {
				path = this.$global.SERVER_SUBFILE +'json/hotIntroduce'+this.$store.state.hotId +'.json'
			}
			
			let params = {
				params: {
					hotId: this.$store.state.hotId
				}
			}
			this.$global.axios
				.get(path, params)
				.then(res => {
						if (res.data.success) {
							console.log(res)
								this.introduce.title = res.data.data[0].title
								this.introduce.content = res.data.data[0].content
								this.introduce.imgList = []
								if(res.data.data[0].url1 != 'undefined' &&res.data.data[0].url1 != "") {
									this.introduce.imgList.push(res.data.data[0].url1)
								}
								if(res.data.data[0].url2 != 'undefined' && res.data.data[0].url1 != "") {
									this.introduce.imgList.push(res.data.data[0].url1)
								}
								if(res.data.data[0].url3 != 'undefined' && res.data.data[0].url1 != "") {
									this.introduce.imgList.push(res.data.data[0].url3)
								}
							} else {
								this.$message.error('失败' + res.data.msg)
							}
							})
							
						},
						methods: {

						}
					}
</script>

<style scoped="scoped">
	.hotContent {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.cardBox {
		width: 65vw;
		height: 60vh;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.leftCard {
		width: 45%;
		height: 90%;
		position: relative;
		background-color: yellow;
		border-radius: 4px
	}

	.rightCard {
		width: 45%;
		height: 90%;
		position: relative;
		background-color: yellow;
		border-radius: 4px
	}

	.box-card {
		position: absolute;
		width: 100%;
		height: 100%;
	}
</style>
